export const BAR_AG_GRID_I18N = {
    CHOOSE_DATE: 'Kies een datum',
    BOOLEAN_FILTER: {
        SHOW_ALL: 'Toon alles',
        TRUE: 'Is waar',
        FALSE: 'Is niet waar'
    }
} as const;
